import { render, staticRenderFns } from "./GFLoanBankDataForm.vue?vue&type=template&id=25c2ea8a"
import script from "./GFLoanBankDataForm.vue?vue&type=script&lang=js"
export * from "./GFLoanBankDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports